"use client";
import { memo } from "react";
import CoreTeamComponent, {
  CoreTeamProps,
} from "../Chat/Charts/token/About/CoreTeam";
import { ViewMoreButton } from "./ViewMoreButton";

const CoreTeam = memo(({ teamMembers }: Pick<CoreTeamProps, "teamMembers">) => {
  return (
    <CoreTeamComponent
      teamMembers={teamMembers}
      containerClassName="gap-2"
      titleClassName="!headline_regular_s text-content_primary"
      nameClassName="!body_medium_s"
      roleClassName="!body_s"
      memberItemClassName="py-1.5 pl-2 pr-3 rounded-2 gap-2"
      imageHeight={24}
      imageWidth={24}
      enableViewMore={true}
      viewMoreText={<ViewMoreButton iconSize={12} />}
    />
  );
});

CoreTeam.displayName = "CoreTeam";

export { CoreTeam };
export type { CoreTeamProps };
